import { Typography } from '@mui/material';
import { Column } from '@/components/content/HdmSkucomparer/parts/Column';
import { columnTextStyles } from '@/components/content/HdmSkucomparer/styles';

export const ColumnText = ({
	text,
	name,
	...props
}: {
	text: string | undefined | null;
	name: string;
	isVisible?: boolean;
	isMainProduct?: boolean;
}) => (
	<Column sx={columnTextStyles.container} {...props}>
		<Typography variant="bodyCaption" sx={columnTextStyles.name}>
			{name}
		</Typography>

		<Typography variant="body1" color={text ? undefined : 'grey.300'} sx={columnTextStyles.text}>
			{text ? text : '-'}
		</Typography>
	</Column>
);
